var __defProp = Object.defineProperty;
var __name = (target, value) => __defProp(target, "name", { value, configurable: true });
const initPromoCard = /* @__PURE__ */ __name(function($el, settings) {
  var _a, _b;
  const readJSON = /* @__PURE__ */ __name((sel, fallback) => {
    try {
      const node = $el.querySelector(sel);
      return node ? JSON.parse(node.textContent || "") : fallback;
    } catch (e) {
      return fallback;
    }
  }, "readJSON");
  const VARIANTS = readJSON("[data-bmsm-variants]", []);
  const TIERS = Array.from($el.querySelectorAll("[data-bmsm-tier]")).map((n) => {
    try {
      return JSON.parse(n.textContent || "");
    } catch (e) {
      return null;
    }
  }).filter(Boolean);
  const MAXP = 1 + TIERS.length;
  const SHIP_THRESHOLD = (_a = settings.free_shipping_threshold) != null ? _a : 2;
  const START_COUNT = Math.min(Math.max((_b = settings.starting_pair_count) != null ? _b : 2, 1), MAXP);
  const tierAt = /* @__PURE__ */ __name((pos) => pos >= 2 && TIERS[pos - 2] || null, "tierAt");
  return {
    extraPairs: function() {
      if (VARIANTS.length < 2 || MAXP < 2) return [];
      const n = Math.max(START_COUNT - 1, 0);
      return Array.from({ length: n }, () => null);
    }(),
    added: false,
    adding: false,
    now: Date.now(),
    urgency: !!settings.urgency,
    countdownTarget: 0,
    variants: VARIANTS,
    pair1Id: null,
    _bound: false,
    init() {
      this.computeCountdownTarget();
      setInterval(() => {
        this.now = Date.now();
      }, 1e3);
      this.bindPair1();
      this.$nextTick(() => {
        if (this.extraPairs.length && typeof this.extraPairs[0] !== "number") {
          const cur = this.currentVariantId;
          const alt = VARIANTS.find((v) => v.available && v.id !== cur) || VARIANTS.find((v) => v.available);
          if (alt) this.extraPairs[0] = alt.id;
        }
      });
    },
    computeCountdownTarget() {
      if (!this.urgency) return;
      if (settings.countdown_type === "duration_offset") {
        const hours = settings.duration_offset_hours || 24;
        this.countdownTarget = Date.now() + hours * 36e5;
        return;
      }
      const tz = settings.timezone;
      const offsetHours = !tz || tz === "user" ? -((/* @__PURE__ */ new Date()).getTimezoneOffset() / 60) : parseFloat(tz);
      const base = /* @__PURE__ */ new Date(`${settings.end_date || "2025-12-31"}T${settings.end_time || "23:59:59"}`);
      this.countdownTarget = base.getTime() - offsetHours * 36e5;
    },
    get countdown() {
      const distance = this.countdownTarget - this.now;
      if (distance <= 0) return "00:00:00";
      const totalH = Math.floor(distance / 36e5);
      const m = Math.floor(distance % 36e5 / 6e4);
      const s = Math.floor(distance % 6e4 / 1e3);
      const pad = /* @__PURE__ */ __name((n) => String(n).padStart(2, "0"), "pad");
      return `${pad(totalH)}:${pad(m)}:${pad(s)}`;
    },
    get showCountdown() {
      return this.urgency && this.countdownTarget - this.now > 0;
    },
    byId(id) {
      return VARIANTS.find((v) => v.id === id);
    },
    sizedImg(url) {
      if (!url) return "";
      return `${url + (url.indexOf("?") > -1 ? "&" : "?")}width=120`;
    },
    money(cents) {
      cents = Math.round(cents);
      if (window.utils && typeof window.utils.formatMoney === "function") {
        return window.utils.formatMoney(cents);
      }
      const n = cents / 100;
      return `$${Number.isInteger(n) ? n : n.toFixed(2)}`;
    },
    ord(n) {
      const s = ["th", "st", "nd", "rd"];
      const v = n % 100;
      return n + (s[(v - 20) % 10] || s[v] || s[0]);
    },
    rewardWord(spec) {
      return spec.free ? "free" : typeof spec.off === "number" ? `${this.money(spec.off)} off` : `${spec.pct}% off`;
    },
    rewardBadge(spec) {
      if (spec.badge) return spec.badge;
      return spec.free ? "FREE" : typeof spec.off === "number" ? `${this.money(spec.off)} OFF`.toUpperCase() : `${spec.pct}% OFF`;
    },
    rewardApplied(spec) {
      if (spec.applied) return spec.applied;
      return spec.free ? "Free with deal" : typeof spec.off === "number" ? `${this.money(spec.off)} off applied` : `${spec.pct}% off applied`;
    },
    fallbackId() {
      const url = new URL(window.location.href);
      const q = +url.searchParams.get("variant");
      if (q && this.byId(q)) return q;
      const avail = VARIANTS.find((v) => v.available);
      return avail ? avail.id : VARIANTS[0] && VARIANTS[0].id;
    },
    bindPair1() {
      this.pair1Id = this.fallbackId();
      const form = $el.closest('form[data-section-type="main_product"]');
      if (!form || !window.Alpine) return;
      const bind = /* @__PURE__ */ __name(() => {
        var _a2;
        if (this._bound) return true;
        const scope = (_a2 = form._x_dataStack) == null ? void 0 : _a2.find((s) => s && s.pdp && "selected_variant" in s.pdp);
        if (!scope) return false;
        this._bound = true;
        window.Alpine.effect(() => {
          var _a3;
          const sv = (_a3 = scope.pdp) == null ? void 0 : _a3.selected_variant;
          this.pair1Id = sv && sv.id ? sv.id : this.fallbackId();
        });
        return true;
      }, "bind");
      if (bind()) return;
      let tries = 0;
      const iv = setInterval(() => {
        if (bind() || ++tries > 40) clearInterval(iv);
      }, 120);
    },
    get currentVariantId() {
      return this.pair1Id && this.byId(this.pair1Id) ? this.pair1Id : this.fallbackId();
    },
    get pairIds() {
      return [this.currentVariantId].concat(this.extraPairs);
    },
    get N() {
      return this.pairIds.length;
    },
    get rewardPos() {
      return this.N >= 2 ? Math.min(this.N, MAXP) : 0;
    },
    get rewardSpec() {
      return this.rewardPos ? tierAt(this.rewardPos) : null;
    },
    get allPicked() {
      return this.extraPairs.every((x) => typeof x === "number");
    },
    get rewardActive() {
      if (!this.rewardPos) return false;
      return this.pairIds.slice(0, this.rewardPos).every((x) => typeof x === "number");
    },
    get rewardIndex() {
      if (!this.rewardPos) return -1;
      if (!this.rewardActive) return this.rewardPos - 1;
      let index = -1;
      let lowest = Infinity;
      this.pairIds.forEach((id, idx) => {
        var _a2;
        if (typeof id !== "number") return;
        const price = (_a2 = this.byId(id)) == null ? void 0 : _a2.price;
        if (typeof price !== "number" || price >= lowest) return;
        lowest = price;
        index = idx;
      });
      return index === -1 ? this.rewardPos - 1 : index;
    },
    priceAt(pos, id) {
      const v = this.byId(id);
      if (!v) return 0;
      const base = v.price;
      if (pos - 1 === this.rewardIndex && this.rewardActive && this.rewardSpec) {
        const s = this.rewardSpec;
        if (s.free) return 0;
        if (typeof s.off === "number") return Math.max(0, base - s.off);
        if (typeof s.pct === "number") return Math.round(base * (1 - s.pct / 100));
      }
      return base;
    },
    get pairViews() {
      return this.pairIds.map((id, idx) => {
        const pos = idx + 1;
        const isReward = idx === this.rewardIndex;
        const picked = typeof id === "number";
        const v = picked ? this.byId(id) : null;
        const u = picked ? this.priceAt(pos, id) : 0;
        const full = picked && v ? v.price : 0;
        return {
          extraIndex: idx - 1,
          isChooser: idx >= 1 && !picked,
          reward: isReward,
          badge: isReward && this.rewardSpec ? this.rewardBadge(this.rewardSpec) : "",
          chooseLabel: `Pair ${pos}`,
          label: `Pair ${pos}${v ? ` \xB7 ${v.color}` : ""}`,
          img: v ? this.sizedImg(v.img) : "",
          tag: isReward && this.rewardActive && this.rewardSpec ? this.rewardApplied(this.rewardSpec) : "",
          priceText: u === 0 ? "Free" : this.money(u),
          wasText: this.money(full),
          discounted: picked && u < full - 1,
          removable: idx >= 1,
          variantId: id
        };
      });
    },
    get orig() {
      let t = 0;
      this.pairIds.forEach((id) => {
        var _a2, _b2;
        if (typeof id === "number") t += (_b2 = (_a2 = this.byId(id)) == null ? void 0 : _a2.price) != null ? _b2 : 0;
      });
      return t;
    },
    get total() {
      let t = 0;
      this.pairIds.forEach((id, i) => {
        if (typeof id === "number") t += this.priceAt(i + 1, id);
      });
      return t;
    },
    get saved() {
      return this.orig - this.total;
    },
    get pickedCount() {
      return this.pairIds.filter((x) => typeof x === "number").length;
    },
    get canAdd() {
      return this.allPicked && this.N < MAXP;
    },
    get shipOk() {
      return SHIP_THRESHOLD > 0 && this.pickedCount >= SHIP_THRESHOLD;
    },
    get showShipNudge() {
      return SHIP_THRESHOLD > 0;
    },
    get tag() {
      const s = this.rewardSpec;
      if (settings.tag) return settings.tag;
      return s ? `${this.ord(this.rewardPos)} pair ${this.rewardWord(s)}` : "Buy more, save more";
    },
    get headline() {
      const s = this.rewardSpec;
      if (s && s.headline) return s.headline;
      if (!s) return settings.headline || "Buy more, save more";
      const o = this.ord(this.rewardPos);
      return this.rewardActive ? `Your ${o} pair is ${this.rewardWord(s)}` : `Pick your ${o} pair to save`;
    },
    get sub() {
      return settings.sub || "The more pairs you add, the more you save.";
    },
    get progressText() {
      const s = this.rewardSpec;
      const nextPos = this.N + 1;
      const nextSpec = nextPos <= MAXP ? tierAt(nextPos) : null;
      const firstTier = tierAt(2);
      if (!s) return firstTier ? `Add a 2nd pair to take ${this.rewardWord(firstTier)}` : "";
      if (!this.rewardActive) return "Pick a colour for every pair to lock in your savings";
      if (nextSpec) return `Add a ${this.ord(nextPos)} pair and it\u2019s <b>${this.rewardWord(nextSpec)}</b>`;
      return `You\u2019ve unlocked the top reward \u2014 the ${this.ord(this.rewardPos)} pair free`;
    },
    get addLabel() {
      const nextPos = this.N + 1;
      const nextSpec = nextPos <= MAXP ? tierAt(nextPos) : null;
      if (nextSpec && nextSpec.cta) return nextSpec.cta;
      return nextSpec ? `+ Add a ${this.ord(nextPos)} pair \u2014 ${this.rewardWord(nextSpec)}` : "+ Add another pair";
    },
    get showTotals() {
      return this.saved > 0 && this.allPicked;
    },
    get originalText() {
      return this.money(this.orig);
    },
    get nowText() {
      return this.money(this.total);
    },
    get savedText() {
      return `Save ${this.money(this.saved)}`;
    },
    get shipNudge() {
      return this.shipOk ? "Free shipping included on this order" : `Add a ${this.ord(SHIP_THRESHOLD)} pair to unlock free shipping`;
    },
    get showAtcPrice() {
      return !this.added;
    },
    get atcLabel() {
      return this.added ? "Added \u2713" : "Add to cart";
    },
    get hasLadder() {
      return TIERS.length > 0;
    },
    setPairColor(extraIndex, id) {
      this.extraPairs[extraIndex] = id;
    },
    removePair(extraIndex) {
      this.extraPairs.splice(extraIndex, 1);
    },
    addPair() {
      if (this.canAdd) this.extraPairs.push(null);
    },
    async addToCart() {
      if (!this.allPicked || this.adding) return;
      this.adding = true;
      const bundleId = `bmsm-${Date.now().toString(36)}`;
      const items = this.pairIds.map((id, i) => {
        const pos = i + 1;
        const isReward = i === this.rewardIndex && this.rewardActive;
        const props = { _bmsm_bundle: bundleId, _bmsm_pair: String(pos) };
        if (isReward && this.rewardSpec) {
          props._bmsm_reward = this.rewardSpec.free ? "free" : typeof this.rewardSpec.off === "number" ? `${this.rewardSpec.off}-off` : `${this.rewardSpec.pct}-pct`;
        }
        return { id, quantity: 1, properties: props };
      });
      try {
        await window._cart.add({ items });
        if (window._stores && window._stores.modal && window._stores.modal.setId) {
          window._stores.modal.setId("modal--cart-drawer");
        }
        this.added = true;
        setTimeout(() => {
          this.added = false;
        }, 1700);
      } catch (e) {
        console.error("[bmsm] add to cart failed", e);
      } finally {
        this.adding = false;
      }
    }
  };
}, "initPromoCard");
window._sections["initPromoCard"] = initPromoCard;
